module.exports = __webpack_public_path__ + "static/media/logo-light.c704220b.svg";